export default "__VITE_ASSET__BZ8EmSN3__"